export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'boltHome' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "boltSynopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' },
	{ id: 'boltTextPage', getter: () => import(/* webpackChunkName: "boltTextPage" */ 'components/bolt/text/text'), component: 'text' },
	{ id: 'boltIframe', getter: () => import(/* webpackChunkName: "boltIframe" */ 'components/bolt/iframe/iframe'), component: 'iframe' },
	{ id: 'boltExpandableTextPage', getter: () => import(/* webpackChunkName: "boltExpandableTextPage" */ 'components/bolt/expandableTextList/expandableTextList'), component: 'expandableTextList' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
